import { IGridWallRequest } from '@api/models';
import OverflowTooltip from '@components/OverflowTooltip/OverflowTooltip';
import { Table } from '@hyperflake/react-ui-library';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';

interface IGridWallRequestProps {
    isLoading: boolean;
    gridwallRequests: IGridWallRequest[];
}

const GridwallRequestList = (props: IGridWallRequestProps) => {
    const { isLoading, gridwallRequests } = props;

    const navigate = useNavigate();
    return (
        <Table
            className="mt-6"
            hover
            borderStyle="divider"
            isLoading={isLoading}
            data={gridwallRequests}
            columns={[
                { header: 'ID' },
                { header: 'GridWall Name' },
                { header: 'Client' },
                { header: 'User' },
                { header: 'Remarks' },
                { header: 'Created At' },
            ]}
            renderRow={(row) => (
                <Table.Row key={row._id} onClick={() => navigate(row._id)}>
                    <Table.Cell>{row._id}</Table.Cell>
                    <Table.Cell>{row.name}</Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${row.client._id}/client-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row.client.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>{row.user.name}</Table.Cell>
                    <Table.Cell>
                        {' '}
                        <OverflowTooltip className="max-w-[50vw]">{row.remarks}</OverflowTooltip>
                    </Table.Cell>

                    <Table.Cell>
                        <span className="text-sm">{moment(row.createdAt).format('HH:mm A - DD MMM YYYY')}</span>
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default GridwallRequestList;
